import Communications from './communications.service';
import {FormikErrors} from "formik";
import axios, {CancelTokenSource} from "axios";
import ApiService from './api.service';
import moment, {Moment} from "moment";
import AlertService from "./alert.service";
import * as yup from "yup";
import {IConfirmationConfig} from "../models/confirmation.model";
import _ from "lodash";
import LocalStorageService from "../services/local-storage.service";
import {eachDayOfInterval, format} from 'date-fns';

export const GLOBAL_DATE_FORMAT = 'YYYY-MM-DD';
yup.addMethod(yup.mixed, 'atLeastOne', (args) => {
    const {message} = args;
    // @ts-expect-error disabled type error
    return this.test('atLeastOne', message, (list: any) => {
        // If there are 2+ elements after filtering, we know atMostOne must be false.
        return Object.keys(list).filter(item => item).length > 0
    })
});

export const NUMBER_OF_TAGS_VISIBLE = 2;
export const CurrentDate: Moment = moment();

const getBytesInMB = (bytes: number) => {
    return bytes / (1024 * 1024);
}

const formatSizeUnits = (bytes: number, decimals = 2) => {
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const getRandomID = (length: number = 10) => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
const handleErrors = ((setErrors: (errors: FormikErrors<any>) => void, err: any, showGlobalError: boolean = false) => {
    if (err.errors) {
        const errors: any = {};
        for (const field in err.errors) {
            const error = err.errors[field];
            if (Object.prototype.hasOwnProperty.call(err.errors, field)) {
                errors[field] = error;
            }
        }
        setErrors(errors);
    }
    if (err.error) {
        AlertService.showToast(err.error);
    } else {
        if (showGlobalError) {
            AlertService.showToast('Form contain errors, please check once', 'error');
        }
    }

});

const openDialog = (component: any) => {
    return new Promise((resolve, reject) => {
        Communications.DialogStateSubject.next({component, promise: {resolve, reject}})
    });
}

const getCancelToken = (): CancelTokenSource => {
    return axios.CancelToken.source();
}

const getPayloadFilterDates = (mode: 'Day' | 'Week' | 'Month' | 'Year'): { start_date: string, end_date: string } => {
    const payload = {start_date: '', end_date: moment().endOf('day').format(GLOBAL_DATE_FORMAT)}
    switch (mode) {
        case "Day":
            payload.start_date = moment().startOf('day').format(GLOBAL_DATE_FORMAT)
            break;
        case "Week":
            payload.start_date = moment().subtract(1, 'week').startOf('day').format(GLOBAL_DATE_FORMAT)
            break;
        case "Month":
            payload.start_date = moment().subtract(1, "month").startOf('day').format(GLOBAL_DATE_FORMAT)
            break;
        case "Year":
            payload.start_date = moment().subtract(1, "year").startOf('day').format(GLOBAL_DATE_FORMAT)
            break;
    }
    return payload;
}

const transformTimeStamp = (date: Date | string | undefined) => {
    return moment(date).format('DD-MMM-YYYY | hh:mm A');
}

const transformTimeStamp2 = (date: Date | string | undefined) => {
    return moment(date).format('hh:mm A, DD-MMM-YYYY ');
}


const convertDateFormat = (date: Date, format: string = GLOBAL_DATE_FORMAT) => {
    return moment(date).format(format);
}


const convertDateFormat2 = (date: Date, format: string = 'DD-MMM-YYYY') => {
    return moment(date).format(format);
}

const generateUseCaseFromCaseDetails = (case_details: any) => {
    return `${CommonService.convertDateFormat2(case_details?.case_date)} - ${case_details?.injury_details?.map((bodyPart: any, index: number) => {
        return (bodyPart?.body_part_details + (bodyPart?.body_side ? `( ${bodyPart.body_side} )` : ' ') + (index !== case_details?.injury_details?.length - 1 ? ' | ' : ''))
    })} `
}

const generateUseCaseFromCaseDetails2 = (case_details: any) => {
    return `${CommonService.convertDateFormat2(case_details?.case_date)} - ${case_details?.injury_details?.map((bodyPart: any, index: number) => {
        return (bodyPart?.body_part_name + (bodyPart?.body_side ? `( ${bodyPart.body_side} )` : ' ') + (index !== case_details?.injury_details?.length - 1 ? ' | ' : ''))
    })} `
}

const generateInterventionNameFromMedicalRecord = (medicalRecordDetails: any) => {
    return `${CommonService.convertDateFormat2(medicalRecordDetails?.created_at)} - ${medicalRecordDetails?.injury_details?.map((bodyPart: any, index: number) => {
        return (bodyPart?.body_part_details?.name + '(' + bodyPart?.body_side + ')' + (index === medicalRecordDetails?.injury_details?.length - 1 ? ' ' : '|'))
    })}  `
}

const getTheDifferenceBetweenDates = (fromDate: string) => {
    const a = moment();
    const b = moment(moment(fromDate), 'YYYY');
    const diff = a.diff(b, 'years')
    return diff;
}

const convertNumberToTime = (number: any) => {
    let hours = Math.floor(number / 60) % 12;
    const minutes = Math.floor((number % 60) * 2);

    const period = hours < 12 ? 'AM' : 'PM';
    hours = hours === 0 ? 12 : hours;

    return `${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
};


const getFlatJsonFromNestedJSON = (jsonData: any, rootName: string = "", ignoreList: any[] = []): any => {

    const appendFormData = (data: any, root: any) => {
        let newObj: any = {};
        let tmp: any = {};
        if (!ignore(root)) {
            root = root || '';
            if (data instanceof File) {
                newObj[root] = data;
            } else if (Array.isArray(data)) {
                for (let i = 0; i < data.length; i++) {
                    tmp = appendFormData(data[i], root + '[' + i + ']');
                    newObj = {...newObj, ...tmp}
                }
            } else if (typeof data === 'object' && data) {
                for (const key in data) {
                    if (Object.prototype.hasOwnProperty.call(data, key)) {
                        if (root === '') {
                            tmp = appendFormData(data[key], key);
                            newObj = {...newObj, ...tmp}
                        } else {
                            tmp = appendFormData(data[key], root + '.' + key);
                            newObj = {...newObj, ...tmp}
                        }
                    }
                }
            } else {
                if (data !== null && typeof data !== 'undefined') {
                    newObj[root] = data;
                }
            }
        }
        return newObj;
    }

    const ignore = (root: any) => {
        return Array.isArray(ignoreList)
            && ignoreList.some((x) => {
                return x === root;
            });
    }

    return appendFormData(jsonData, rootName);
};

const getFormDataFromJSON = (obj: any, rootName = '', ignoreList = []): FormData => {

    const formData = new FormData();

    const appendFormData = (data: any, root: any) => {
        if (!ignore(root)) {
            root = root || '';
            if (data instanceof File) {
                formData.append(root, data);
            } else if (Array.isArray(data)) {
                for (let i = 0; i < data.length; i++) {
                    appendFormData(data[i], root + '[' + i + ']');
                }
            } else if (typeof data === 'object' && data) {
                for (const key in data) {
                    if (Object.prototype.hasOwnProperty.call(data, key)) {
                        if (root === '') {
                            appendFormData(data[key], key);
                        } else {
                            appendFormData(data[key], root + '.' + key);
                        }
                    }
                }
            } else {
                if (data !== null && typeof data !== 'undefined') {
                    formData.append(root, data);
                }
            }
        }
    }

    const ignore = (root: any) => {
        return Array.isArray(ignoreList)
            && ignoreList.some((x: any) => {
                return x === root;
            });
    }

    appendFormData(obj, rootName);

    return formData;
}

const capitalizeFirstLetter = (string: string | undefined) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const kFormatter = (num: any) => {
    // @ts-expect-error disabled type error
    return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
}

const getLettersFromNumber = (number: number) => {
    const previousLetters: any = (number >= 26 ? getLettersFromNumber(Math.floor(number / 26) - 1) : '');
    const lastLetter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[number % 26];
    return previousLetters + lastLetter;
}

const getRandomNumberBetweenRange = (startingNumber: number, endingNumber: number) => {
    startingNumber = Math.ceil(startingNumber);
    endingNumber = Math.floor(endingNumber);
    return Math.floor(Math.random() * (endingNumber - startingNumber + 1)) + startingNumber;
}

const getMinsAndSecondsFromSeconds = (numberOfSeconds: number) => {
    const minutes = Math.floor(numberOfSeconds / 60);
    const seconds = (numberOfSeconds % 60);
    return {
        minutes: minutes < 10 ? '0' + minutes : minutes,
        seconds: seconds < 10 ? '0' + seconds : seconds
    }
}


const downloadFile = (url: string, fileName: any, type = 'pdf') => {
    switch (type) {
        case 'image':
            axios.get(url, {
                headers: {'Content-Type': 'image/*'}
            }).then(
                (data: any) => {
                    const blob = new Blob([data], {
                        type: 'image/*' // must match the Accept type
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                }, () => {
                    console.log('error')
                });
            break;
        case 'pdf':
            axios.get(url, {
                headers: {Accept: 'application/pdf'}, responseType: 'arraybuffer'
            }).then(
                (data: any) => {
                    const blob = new Blob([data.data], {
                        type: 'application/pdf' // must match the Accept type
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                }, () => {
                    console.log('error')
                });
            break;
        case 'csv':
            axios.get(url, {
                headers: {Accept: 'application/csv'}, responseType: 'blob'
            }).then(
                (response: any) => {
                    const blob = new Blob([response.data], {
                        type: "application/octet-stream" // or Content-type: "application/vnd.ms-excel"
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                }, () => {
                    console.log('error')
                });
            break;
        case 'xlsx':
            axios.get(url, {
                headers: {Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
                responseType: 'blob'
            }).then(
                (response: any) => {
                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                }, () => {
                    console.log('error')
                });
            break;
        default:
            console.log(type, ' file download not supported');
    }
}

const generateBlobFileFromUrl = (attachmentUrl: string, attachmentTitle: string, attachmentType: string) => {
    return fetch(attachmentUrl)
        .then((res) => res.blob())
        .then((myBlob) => {
            const myFile = new File([myBlob], attachmentTitle, {
                type: attachmentType
            });
            return myFile;
        });
};

const getFlatQuestionList = (stepData: any): any => {
    const flatQuestionList: any = [];
    const questionListParser = (arrayData: []) => {
        arrayData.forEach((option: any) => {
            if (option?.questions) {
                option?.questions.forEach((question: any) => {
                    flatQuestionList.push(question);
                    if (question?.options) {
                        questionListParser(question?.options);
                    }
                })
            }
        })
    }
    if (stepData?.questions) {
        stepData?.questions.forEach((value: any) => {
            flatQuestionList.push(value);
            if (value?.options) {
                questionListParser(value?.options);
            }
        })
    }
    return flatQuestionList;

};

const getArrayOfValuesOfOneKeyFromJSON = (array: any[], key: string) => {
    if (array && array.length > 0) {
        const arrayWithDesiredKeyValue = array.map((item) => {
            return item[key];
        });
        return arrayWithDesiredKeyValue;
    } else {
        return [];
    }
}

const onConfirm = (config: IConfirmationConfig = {}) => {
    return new Promise((resolve, reject) => {
        Communications.ConfirmStateSubject.next({config, promise: {resolve, reject}})
    });
}

const Capitalize = (str: string) => {
    const capitalize = (str: string) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return str.split(' ').map(capitalize).join(' ');
}

const getObjectKeyValue = (object: any, key: string) => {
    return _.get(object, key);
}

const getSystemFormatTimeStamp = (date: Date | string, showTime: boolean = false) => {
    if (!date) {
        return ""
    }
    if (showTime) {
        return moment(date).format('DD-MMM-YYYY, hh:mm A');
    } else {
        return moment(date).format('DD-MMM-YYYY');
    }
};

const removeKeysFromJSON = (obj: any, keys: string[]): any => {
    for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            switch (typeof (obj[prop])) {
                case 'object':
                    if (keys.indexOf(prop) > -1) {
                        delete obj[prop];
                    } else {
                        removeKeysFromJSON(obj[prop], keys);
                    }
                    break;
                default:
                    if (keys.indexOf(prop) > -1) {
                        delete obj[prop];
                    }
                    break;
            }
        }
    }
    return obj;
}

const isEqual = (a: any, b: any) => {
    return _.isEqual(a, b);
}

const formatPhoneNumber = (phone: string) => {
    if (typeof phone !== 'string') {
        return '';
    }
    const x = phone?.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (x) {
        phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }
    return phone
}

const formatPhoneNumberToUS = (number: string) => {
    const cleaned = ('' + number).replace(/\D/g, ''); // Remove all non-digit characters
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/); // Match groups of digits

    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`; // Format as (XXX) XXX-XXXX
    }

    return number; // Return original number if it doesn't match expected format
}

const validateDecimal = (input: any) => {
    const regex = /^\d*\.?\d{0,2}$/; // Regular expression to allow up to two decimal places
    const inputValue = input.value;

    if (!regex.test(inputValue)) {
        input.value = inputValue.slice(0, -1); // Remove the last character (the extra decimal)
    }
}

const extractName = (data: any) => {
    return (data?.first_name || data?.last_name ? data?.last_name + ', ' + data?.first_name : '-');
};

const getNormalizedFileType = (fileType: any) => {
    let type: any = fileType;
    if (type.includes('image')) {
        type = "image";
    } else if (type.includes('pdf')) {
        type = "pdf";
    } else if (type.includes('word')) {
        type = "word";
    } else if (type.includes('spreadsheet')) {
        type = "xls";
    } else if (type.includes('video')) {
        type = "video";
    } else {
        type = "application";
    }
    return type;
}

const openLinkInNewTab = (url: string) => {
    window.open(url, '_blank');
}

const isTextEllipsisActive = (e: HTMLDivElement) => {
    return (e.offsetWidth < e.scrollWidth);
}

const getNameInitials = (name: string) => {
    const names = name.split(' ');
    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
}

const getContrastYIQ = (hexcolor: string) => {
    const r = parseInt(hexcolor.substring(1, 3), 16);
    const g = parseInt(hexcolor.substring(3, 5), 16);
    const b = parseInt(hexcolor.substring(5, 7), 16);
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? 'black' : 'white';
}

const LightenDarkenColor = (col: any, amt: number) => {
    col = parseInt(col, 16);
    return (((col & 0x0000FF) + amt) | ((((col >> 8) & 0x00FF) + amt) << 8) | (((col >> 16) + amt) << 16)).toString(16)
}

const ComingSoon = () => {
    AlertService.showToast("Coming Soon", 'info');
}

const cleanMentionsPayload = (value: string, mentionsData: any) => {
    const ids = mentionsData?.map((item: any) => item.id);
    let cleanedValue: string = value;
    if (ids.length) {
        ids.forEach((id: any) => {
            cleanedValue = cleanedValue?.replaceAll(new RegExp(`\\(${id}\\)`, 'g'), '');
        });
    }
    cleanedValue = cleanedValue?.split('\n').join("\\n");
    return cleanedValue;
}

const cleanMentionsResponse = (value: string, mentionsData: any) => {
    const ids = mentionsData?.map((item: any) => item.id);
    let cleanedValue: string = value;
    if (ids?.length) {
        ids.forEach((id: any) => {
            cleanedValue = cleanedValue?.replaceAll(`@[${id}]`, `@${id}`)
        });
    }
    cleanedValue = cleanedValue?.split('\\n').join("<br />");
    return cleanedValue || '-';
}

const editMentionsFormat = (value: string, mentionsData: any) => {
    const ids = mentionsData?.map((item: any) => item.id);
    let cleanedValue: string = value;
    if (ids?.length) {
        ids?.forEach((id: any) => {
            cleanedValue = cleanedValue?.split(`@[${id}]`).join(`@[${id}](${id})`);
        });
    }
    cleanedValue = cleanedValue?.split('\\n').join("\n");
    return cleanedValue;
}

const convertToDecimals = (value: number | string) => {
    if (typeof (value) !== "number") {
        return
    }
    if (typeof (value) === 'string') {
        const tempValue = +(value)
        return tempValue.toFixed(2)
    }
    if (!value) return 0;
    return value.toFixed(2)
}

const calculateFinalAmountFromDiscountPercentage = (percentage: any, totalAmount: number) => {
    return (parseFloat(percentage) / 100) * totalAmount;
}

const getHoursAndMinutesFromMinutes = (minutes: number) => {
    return moment().startOf('day').add(minutes, 'minutes').format('hh:mm A');
}

const areArraysEqual = (arr1: any[], arr2: any[]) => {
    // Check if arrays have the same length
    if (arr1.length !== arr2.length) {
        return false;
    }

    // Check if all elements in the same index are equal
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }

    // Arrays are equal
    return true;
}


// const generateTimeSlots = (startTime: any, endTime: any) => {
//     console.log(startTime, endTime);
//     const timeSlots = [];
//     while (startTime < endTime) {
//         console.log(startTime);
//         const hours = Math.floor(startTime / 60);
//         const minutes = startTime % 60;
//         const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
//         timeSlots.push({code: startTime, title: formattedTime});
//         startTime += 60; // Add one hour in minutes
//     }
//     console.log(timeSlots);
//     return timeSlots;
// };

const generateTimeSlots = (startTime: number, endTime: number) => {
    const timeSlots = [];
    while (startTime <= endTime) { // Update the condition to <=
        const hours = Math.floor(startTime / 60);
        const minutes = startTime % 60;
        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        timeSlots.push({code: startTime, title: formattedTime});
        startTime += 60; // Add one hour in minutes
    }
    return timeSlots;
};

const EndTimingsList = (time: any) => {
    const startTime = Math.floor(time / 60); // Convert selected start time to hours

    return Array.from(Array(24 - startTime + 1).keys()).map((item: number) => {
        const hour = startTime + item;
        const endTime = moment().hour(hour).minute(0);
        return {
            code: item * 60 >= time, // Change the comparison operator to include the start time
            title: endTime.format('HH:mm'),
        };
    });
};

const ordinalSuffixOf = (i: number) => {
    const j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + "st";
    }
    if (j === 2 && k !== 12) {
        return i + "nd";
    }
    if (j === 3 && k !== 13) {
        return i + "rd";
    }
    return i + "th";
}

const generateDaysBetweenDates = (startDate: string, endDate: string) => {
    return eachDayOfInterval({
        start: new Date(startDate),
        end: new Date(endDate)
    }).map(date => ({
        date: format(date, 'yyyy-MM-dd'),
        day: format(date, 'EEEE')
    }));
};
const getDayName = (dayIndex: number): string => {
    const days = ['Mon', 'Tue', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun'];
    return days[dayIndex] || 'Invalid day';
};

const getDayOfWeek = (dateString: string): string => {
    const date = new Date(dateString);
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return days[date.getUTCDay()];
}
const timeToMinutes = (timeString: string) => {
    if (!timeString) return 0;

    const [hours, minutes] = timeString.split(':').map(Number);
    return (hours * 60) + minutes;
};

const getTimeDifferenceInMinutes = (startTime: string, endTime: string) => {
    console.log(startTime, endTime, 'svsrefsref')
    const startMinutes = timeToMinutes(startTime);
    const endMinutes = timeToMinutes(endTime);

    return endMinutes - startMinutes;
};

const minutesToTime = (totalMinutes: number) => {
    const hours24 = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const period = hours24 >= 12 ? 'PM' : 'AM';
    const hours12 = hours24 % 12 || 12;

    const paddedMinutes = String(minutes).padStart(2, '0');

    return `${hours12}:${paddedMinutes} ${period}`;
};
const formatStatusText = (text: string) => {
    return text
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
const getOperationalDates = (startDateStr: any, endDateStr: any, operatingDays: any) => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const result: any = {};

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
        const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

        // If your mapping is 0 = Monday, adjust like this:
        const customDayOfWeek = (dayOfWeek + 6) % 7;

        if (operatingDays?.includes(customDayOfWeek)) {
            const month = monthNames[currentDate.getMonth()];
            const day = currentDate.getDate();

            if (!result[month]) {
                result[month] = [];
            }

            result[month].push(day);
        }

        currentDate.setDate(currentDate.getDate() + 1);
    }

    // Convert result object to desired string format
    return Object.entries(result)
        .map(([month, days]: any) => `${month} - ${days.join(",")}`)
        .join("\n");
}

const CommonService = {
    LightenDarkenColor,
    getContrastYIQ,
    getNameInitials,
    handleErrors,
    openDialog,
    onConfirm,
    formatSizeUnits,
    getRandomID,
    getBytesInMB,
    getCancelToken,
    getPayloadFilterDates,
    getFormDataFromJSON,
    capitalizeFirstLetter,
    kFormatter,
    getLettersFromNumber,
    getRandomNumberBetweenRange,
    getMinsAndSecondsFromSeconds,
    convertDateFormat,
    downloadFile,
    generateBlobFileFromUrl,
    getFlatJsonFromNestedJSON,
    getFlatQuestionList,
    getArrayOfValuesOfOneKeyFromJSON,
    Capitalize,
    getObjectKeyValue,
    getSystemFormatTimeStamp,
    transformTimeStamp,
    getTheDifferenceBetweenDates,
    removeKeysFromJSON,
    isEqual,
    convertDateFormat2,
    formatPhoneNumber,
    formatPhoneNumberToUS,
    generateInterventionNameFromMedicalRecord,
    extractName,
    getNormalizedFileType,
    openLinkInNewTab,
    isTextEllipsisActive,
    ComingSoon,
    generateUseCaseFromCaseDetails,
    cleanMentionsPayload,
    cleanMentionsResponse,
    editMentionsFormat,
    convertToDecimals,
    calculateFinalAmountFromDiscountPercentage,
    generateUseCaseFromCaseDetails2,
    transformTimeStamp2,
    convertNumberToTime,
    getHoursAndMinutesFromMinutes,
    validateDecimal,
    areArraysEqual,
    generateTimeSlots,
    EndTimingsList,
    ordinalSuffixOf,
    generateDaysBetweenDates,
    getDayName,
    getDayOfWeek,
    timeToMinutes,
    getTimeDifferenceInMinutes,
    minutesToTime,
    formatStatusText,
    getOperationalDates,
    // createValidationsObject,
    // createYupSchema,

    _api: ApiService,
    _communications: Communications,
    _alert: AlertService,
    _localStorage: LocalStorageService,
}
export default CommonService;
